// extracted by mini-css-extract-plugin
module.exports = {"sdgItem":"SDGItem_sdgItem__3g0X0","sdgTooltip":"SDGItem_sdgTooltip__2Tf2P","icon":"SDGItem_icon__D3IKc"};